import {
  STATISTICS_OVERVIEW_BAR_CHART_STORE
} from 'store'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { MSLine } from '../MSLine'
import { EventsPeriodChartProps } from './EventsPeriodChart.types'

const EventsPeriodChartComponent = (props: EventsPeriodChartProps) => {
  const {
    [STATISTICS_OVERVIEW_BAR_CHART_STORE]: {
      eventsPeriodChartProps
    }
  } = props

  return (
    <div style={{ flex: 1 }}>
      <MSLine {...eventsPeriodChartProps} />
    </div>
  )
}

const EventsPeriodChart = inject(
  STATISTICS_OVERVIEW_BAR_CHART_STORE
)(observer(EventsPeriodChartComponent))
export { EventsPeriodChart }
